import { PANEL_WIDTH } from '../components/FloatingPanel/FloatingPanel';
import { type CustomNode } from '../node';

export const NEW_NODE_OFFSET = 150;

export const getSiblingNodesCenterPosition = (siblingNodes: CustomNode[]) => {
  if (siblingNodes.length > 0) {
    const topNodePosition = siblingNodes[0].position;
    const bottomNodePosition = siblingNodes.at(-1)?.position;
    if (topNodePosition && bottomNodePosition) {
      const avgX = (topNodePosition.x + bottomNodePosition.x) / 2;
      const avgY = (topNodePosition.y + bottomNodePosition.y) / 2;
      return { x: avgX + PANEL_WIDTH, y: avgY };
    }
  }
  return { x: PANEL_WIDTH, y: 0 };
};
